// src/connector.ts
import { createConnector } from "wagmi";
import { gemini } from "@gemini-wallet/wagmi";
var geminiRainbowKitConfig = {
  id: "gemini",
  name: "Gemini Wallet",
  shortName: "Gemini",
  rdns: "com.gemini.wallet",
  iconAccent: "#1FC4DF",
  iconBackground: "#1FC4DF",
  iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9IiMxRkM0REYiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjE0NzkgNy4wMDAwMUMxMy42NzkxIDcuMDE0NDYgMTEuNjExIDguOTE4MjcgMTEuMzMzOCAxMS4zMzA0QzguNzcwNzMgMTEuNjAxOCA2Ljg2ODk2IDEzLjgzNTIgNy4wMDcwNyAxNi40MTE2QzcuMTQ1MTggMTguOTg3OSA5LjI3NDc5IDIxLjAwNDggMTEuODUyMiAyMUMxNC4zMjA3IDIwLjk4NTYgMTYuMzg5IDE5LjA4NTIgMTYuNjY2MiAxNi42Njk2QzE5LjIyOTMgMTYuMzk4MiAyMS4xMzEgMTQuMTY0OCAyMC45OTI5IDExLjU4ODRDMjAuODU0OCA5LjAxMiAxOC43MjUyIDYuOTk1MjEgMTYuMTQ3OSA3LjAwMDAxWk0xOS44NTc5IDEyLjM5ODVDMTkuNjA5MSAxNC4wMzI2IDE4LjMyNzcgMTUuMzE1MSAxNi42OTM1IDE1LjU2MzRWMTIuMzk4NUgxOS44NTc5Wk04LjE0MjExIDE1LjYwMzhDOC4zOTA4NiAxMy45NzAzIDkuNjcxNzggMTIuNjg4NSAxMS4zMDM3IDEyLjQ0VjE1LjYwMzhIOC4xNDIxMVpNMTUuNTU5IDE2LjY3OTdDMTUuMjg4OSAxOC42NDE4IDEzLjY4NDQgMjAuMTA3IDExLjg1MDYgMjAuMTA3QzEwLjAxNjkgMjAuMTA3IDguNDEyMjMgMTguNjQxOCA4LjE0MjExIDE2LjY3OTdIMTUuNTU5Wk0xNS42MDM4IDEyLjM5ODVWMTUuNjAzN0gxMi4zOTg2VjEyLjM5ODVIMTUuNjAzOFpNMTkuODU3OSAxMS41MDI0SDEyLjQ0MjdDMTIuNzEyOCA5LjU0MDI2IDE0LjMxNzQgOC4wNzUyIDE2LjE0NzIgOC4wNzUyQzE3Ljk3NyA4LjA3NTIgMTkuNTgxNSA5LjU0MDI2IDE5Ljg1MTcgMTEuNTAyNEgxOS44NTc5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
  installed: true,
  downloadUrls: {
    browserExtension: "https://keys.gemini.com",
    qrCode: "https://keys.gemini.com"
  },
  mobile: {
    getUri: (uri) => uri
  },
  qrCode: {
    getUri: (uri) => uri,
    instructions: {
      learnMoreUrl: "https://keys.gemini.com",
      steps: [
        {
          description: "Download and install the Gemini Wallet browser extension",
          step: "install",
          title: "Install Gemini Wallet"
        },
        {
          description: "Create a new wallet or import an existing one",
          step: "create",
          title: "Set up your wallet"
        },
        {
          description: "Scan the QR code with your Gemini Wallet",
          step: "scan",
          title: "Connect your wallet"
        }
      ]
    }
  },
  extension: {
    instructions: {
      learnMoreUrl: "https://keys.gemini.com",
      steps: [
        {
          description: "Download and install the Gemini Wallet browser extension",
          step: "install",
          title: "Install Gemini Wallet"
        },
        {
          description: "Create a new wallet or import an existing one",
          step: "create",
          title: "Set up your wallet"
        },
        {
          description: "Refresh this page and try connecting again",
          step: "refresh",
          title: "Refresh and connect"
        }
      ]
    }
  }
};
var geminiRainbowKitConnector = (walletConfig) => ({
  ...geminiRainbowKitConfig,
  createConnector: (walletDetails) => {
    const connector = gemini({
      appMetadata: walletConfig
    });
    return createConnector((config) => ({
      ...connector(config),
      ...walletDetails
    }));
  }
});

// src/index.ts
var src_default = "./connector";
export {
  geminiRainbowKitConnector,
  geminiRainbowKitConfig,
  src_default as default
};
